import { getGameState, saveGameState } from '../systems/state.js';
import { eventBus, GameEvents } from '../systems/events.js';

let overlay = null;
let isOpen = false;
let textInput = null;
let selectedStyle = 'driftwood';
let styleButtons = {};

function injectStyles() {
  const style = document.createElement('style');
  style.textContent = `
    #sign-custom-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 950;
      background: rgba(0, 0, 0, 0.6);
      backdrop-filter: blur(4px);
      -webkit-backdrop-filter: blur(4px);
      display: flex;
      justify-content: center;
      align-items: center;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.3s ease;
    }
    #sign-custom-overlay.open {
      opacity: 1;
      pointer-events: auto;
    }

    #sign-custom-panel {
      background: linear-gradient(145deg, #faf0d7 0%, #f0deb0 50%, #e8d5a3 100%);
      border: 3px solid #c4a265;
      border-radius: 20px;
      width: 90%;
      max-width: 420px;
      padding: 28px 24px;
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
      font-family: 'Georgia', serif;
      color: #5a3e1b;
      transform: scale(0.9);
      transition: transform 0.3s ease;
    }
    #sign-custom-overlay.open #sign-custom-panel {
      transform: scale(1);
    }

    .sign-custom-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      border-bottom: 2px solid #c4a265;
      padding-bottom: 12px;
    }
    .sign-custom-title {
      font-size: 22px;
      font-weight: bold;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .sign-custom-close {
      background: none;
      border: 2px solid #c4a265;
      border-radius: 50%;
      width: 36px;
      height: 36px;
      font-size: 20px;
      color: #5a3e1b;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.2s;
      font-family: 'Georgia', serif;
    }
    .sign-custom-close:hover {
      background: #c4a265;
      color: #fff;
    }

    .sign-custom-label {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 8px;
      text-transform: uppercase;
      letter-spacing: 1px;
      opacity: 0.8;
    }

    .sign-custom-text-input {
      width: 100%;
      box-sizing: border-box;
      padding: 10px 14px;
      font-family: 'Georgia', serif;
      font-size: 16px;
      color: #5a3e1b;
      background: linear-gradient(135deg, #fff8e7 0%, #f5e6c8 100%);
      border: 2px solid #d4b87a;
      border-radius: 10px;
      outline: none;
      transition: border-color 0.2s;
    }
    .sign-custom-text-input:focus {
      border-color: #a0853a;
      box-shadow: 0 0 8px rgba(196, 162, 101, 0.4);
    }
    .sign-custom-char-count {
      text-align: right;
      font-size: 12px;
      opacity: 0.6;
      margin-top: 4px;
      margin-bottom: 16px;
    }

    .sign-custom-styles {
      display: flex;
      gap: 10px;
      margin-bottom: 24px;
    }
    .sign-custom-style-btn {
      flex: 1;
      padding: 10px 8px;
      font-family: 'Georgia', serif;
      font-size: 14px;
      font-weight: bold;
      color: #5a3e1b;
      background: linear-gradient(135deg, #fff8e7 0%, #f5e6c8 100%);
      border: 2px solid #d4b87a;
      border-radius: 10px;
      cursor: pointer;
      text-align: center;
      transition: all 0.2s;
      user-select: none;
      -webkit-tap-highlight-color: transparent;
    }
    .sign-custom-style-btn:hover {
      transform: scale(1.03);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    }
    .sign-custom-style-btn.active {
      border-color: #a0853a;
      background: linear-gradient(135deg, #e8d5a3 0%, #d4b87a 100%);
      box-shadow: 0 0 10px rgba(196, 162, 101, 0.5);
    }

    .sign-custom-actions {
      display: flex;
      gap: 12px;
      justify-content: flex-end;
    }
    .sign-custom-btn {
      padding: 10px 22px;
      font-family: 'Georgia', serif;
      font-size: 15px;
      font-weight: bold;
      border-radius: 10px;
      cursor: pointer;
      transition: all 0.2s;
      user-select: none;
      -webkit-tap-highlight-color: transparent;
    }
    .sign-custom-btn:hover {
      transform: scale(1.03);
    }
    .sign-custom-btn:active {
      transform: scale(0.97);
    }
    .sign-custom-btn-cancel {
      color: #5a3e1b;
      background: linear-gradient(135deg, #fff8e7 0%, #f5e6c8 100%);
      border: 2px solid #d4b87a;
    }
    .sign-custom-btn-save {
      color: #fff;
      background: linear-gradient(135deg, #a0853a 0%, #8b7332 100%);
      border: 2px solid #8b7332;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }
    .sign-custom-btn-save:hover {
      box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);
    }

    @media (max-width: 480px) {
      #sign-custom-panel {
        padding: 20px 16px;
      }
      .sign-custom-styles {
        flex-direction: column;
        gap: 8px;
      }
    }
  `;
  document.head.appendChild(style);
}

const STYLE_OPTIONS = [
  { id: 'driftwood', label: 'Driftwood' },
  { id: 'bamboo', label: 'Bamboo' },
  { id: 'stone', label: 'Stone' },
];

function createPanel() {
  overlay = document.createElement('div');
  overlay.id = 'sign-custom-overlay';

  // Close when clicking backdrop
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closePanel();
  });

  const panel = document.createElement('div');
  panel.id = 'sign-custom-panel';

  // Header
  const header = document.createElement('div');
  header.className = 'sign-custom-header';

  const title = document.createElement('div');
  title.className = 'sign-custom-title';
  title.textContent = 'Customize Sign';

  const closeBtn = document.createElement('button');
  closeBtn.className = 'sign-custom-close';
  closeBtn.setAttribute('aria-label', 'Close');
  closeBtn.textContent = '\u00D7';
  closeBtn.addEventListener('click', closePanel);

  header.appendChild(title);
  header.appendChild(closeBtn);
  panel.appendChild(header);

  // Text input section
  const textLabel = document.createElement('div');
  textLabel.className = 'sign-custom-label';
  textLabel.textContent = 'Sign Text';
  panel.appendChild(textLabel);

  textInput = document.createElement('input');
  textInput.type = 'text';
  textInput.className = 'sign-custom-text-input';
  textInput.maxLength = 20;
  textInput.placeholder = 'Enter sign text...';
  panel.appendChild(textInput);

  const charCount = document.createElement('div');
  charCount.className = 'sign-custom-char-count';
  charCount.textContent = '0 / 20';
  panel.appendChild(charCount);

  textInput.addEventListener('input', () => {
    charCount.textContent = `${textInput.value.length} / 20`;
  });

  // Style selector section
  const styleLabel = document.createElement('div');
  styleLabel.className = 'sign-custom-label';
  styleLabel.textContent = 'Sign Style';
  panel.appendChild(styleLabel);

  const stylesRow = document.createElement('div');
  stylesRow.className = 'sign-custom-styles';

  for (const opt of STYLE_OPTIONS) {
    const btn = document.createElement('button');
    btn.className = 'sign-custom-style-btn';
    btn.textContent = opt.label;
    btn.dataset.style = opt.id;
    btn.addEventListener('click', () => {
      selectStyle(opt.id);
    });
    styleButtons[opt.id] = btn;
    stylesRow.appendChild(btn);
  }

  panel.appendChild(stylesRow);

  // Action buttons
  const actions = document.createElement('div');
  actions.className = 'sign-custom-actions';

  const cancelBtn = document.createElement('button');
  cancelBtn.className = 'sign-custom-btn sign-custom-btn-cancel';
  cancelBtn.textContent = 'Cancel';
  cancelBtn.addEventListener('click', closePanel);

  const saveBtn = document.createElement('button');
  saveBtn.className = 'sign-custom-btn sign-custom-btn-save';
  saveBtn.textContent = 'Save';
  saveBtn.addEventListener('click', saveAndClose);

  actions.appendChild(cancelBtn);
  actions.appendChild(saveBtn);
  panel.appendChild(actions);

  overlay.appendChild(panel);
  document.body.appendChild(overlay);
}

function selectStyle(styleId) {
  selectedStyle = styleId;
  for (const [id, btn] of Object.entries(styleButtons)) {
    btn.classList.toggle('active', id === styleId);
  }
}

function openPanel() {
  if (isOpen) return;
  const state = getGameState();
  // Pre-fill with current values
  textInput.value = state.settings.signText || '';
  selectedStyle = state.settings.signStyle || 'driftwood';
  selectStyle(selectedStyle);

  // Update char count
  const charCount = overlay.querySelector('.sign-custom-char-count');
  if (charCount) {
    charCount.textContent = `${textInput.value.length} / 20`;
  }

  isOpen = true;
  overlay.classList.add('open');

  // Focus the text input after the transition
  setTimeout(() => textInput.focus(), 300);
}

function closePanel() {
  if (!isOpen) return;
  isOpen = false;
  overlay.classList.remove('open');
}

function saveAndClose() {
  const state = getGameState();
  const newText = textInput.value.slice(0, 20);
  state.settings.signText = newText;
  state.settings.signStyle = selectedStyle;
  saveGameState(state);

  // Emit event so main.js can update the 3D sign text
  eventBus.emit('sign:updated', {
    text: state.settings.signText,
    style: state.settings.signStyle,
  });

  closePanel();
}

export function initSignCustomization() {
  injectStyles();
  createPanel();

  // Listen for welcome_sign clicks
  eventBus.on(GameEvents.OBJECT_CLICKED, (data) => {
    if (data.id === 'welcome_sign') {
      openPanel();
    }
  });

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen) {
      closePanel();
    }
  });

  console.log('[SignCustomization] Initialized');
}
